import { loadScript } from "./scriptLoader";
import queryString from "query-string";
import _ from "lodash";

export const setupMetrics = (page, isMax) => {
  window.digitalData.page.pageInfo.breadCrumbs = [
    "v2.0",
    "us",
    "en",
    "video-gallery",
    page,
  ];
  if (isMax) {
    window.loadChat = "no";
  }
  loadScript(
    "hfScript",
    "https://h50007.www5.hpe.com/hfws/us/en/hpe/latest.r?contentType=js&switchToCHF=true"
  );
  loadScript(
    "metricsScript",
    "https://www.hpe.com/global/metrics/bootstrap/prod.js"
  );
};

export const isProduction = () => {
  return process.env["REACT_APP_AKAMAIPATH"].indexOf("h22228") !== -1;
};

export const isStaging = () => {
  return process.env["REACT_APP_AKAMAIPATH"].indexOf("h22229") !== -1;
};

export const isPreview = () => {
  return window.location.href.indexOf("preview") !== -1;
};

export const setupRecommendations = (video) => {
  let isTest = isPreview();
  let isITG = isStaging();
  let isProd = isProduction();
  let _uaid = `${video.uaid}`;

  if (
    video.recommendedTrackId !== "" &&
    window.jQuery("#qa-website-inject-items a").length === 0
  ) {
    (function (j, u, k, e, b, o, x) {
      j[b] =
        j[b] ||
        function () {
          (j[b].q = j[b].q || []).push(arguments);
        };
      j[b].l = 1 * new Date();
      o = u.createElement(k);
      x = u.getElementsByTagName(k)[0];
      o.async = 1;
      o.src = e;
      x.parentNode.insertBefore(o, x);
    })(
      window,
      document,
      "script",
      "https://app.cdn.lookbookhq.com/production/jukebox/current/jukebox.js",
      "lbhq"
    );
    window.lbhq("create", "LB-2F4F2B25-10358");
    setTimeout(function () {
      window
        .jQuery("#qa-website-inject-items a")
        .wrap("<div class='pf-item'></div>");
    }, 5000);
  }
  if (
    video.aiWidgetEnabled &&
    window.jQuery(".psn-recommended-item").length === 0
  ) {
    if (isITG || isProd || isTest) {
      let _config = {
        parent: "#aiWidget",
        staticMode: true,
        customJumpId: "videogallery",
        chatCard: true,
        recommendation_type: "mixed",
      };
      let _apiKey = "AIzaSyCcQG7fcXDhH9gQldPto3-QTNphvs_enTc";
      
      let _languageCode = "";
      let psnowUrl = "https://www.hpe.com/psnow/recommend/";

      if (video.aiWidgetEnabled) {
        (function (p, s, n, o, w, r, e, c, m, d) {
          p._psnowRec = arguments;
          m = s.createElement(n);
          d = s.getElementsByTagName(n)[0];
          m.async = 1;
          m.src = o + w + (c ? "?l=" + c : "");
          d.parentNode.insertBefore(m, d);
        })(
          window,
          document,
          "script",
          psnowUrl,
          _uaid,
          _apiKey,
          _config,
          _languageCode
        );
      }
    }
  }
};

export const getMappedLang = (lang) => {
  let urlMapping = [
    { key: "de", value: "de-de" },
    { key: "en", value: "en-us" },
    { key: "es", value: "es-es" },
    { key: "fr", value: "fr-fr" },
    { key: "it", value: "it-it" },
    { key: "ja", value: "ja-jp" },
    { key: "ko", value: "ko-kr" },
    { key: "zh", value: "zh-cn" },
  ];

  return lang
    ? _.find(
      urlMapping,
      (mapping) =>
        mapping.key === lang.toLowerCase() ||
        mapping.value === lang.toLowerCase()
    )
    : undefined;
};

export const setupPlayer = (myPlayer, video, isMax, autoplay = false) => {
  let iframe = `<iframe title='Brightcove Player' src='//players.brightcove.net/${video.accountId}/${video.playerKey}_default/index.html?videoId=ref:${video.referenceId}' allowfullscreen frameborder=0></iframe>`;
  let _uaid = `${video.uaid}`;
  let query = queryString.parse(window.location.search);
  let showCaptions = query.cc === "on";
  let showCaptionsDefined = query.cc !== undefined && (query.cc === "on" || query.cc === "off");
  let timeParam = query.t;

  window.percentViewed25 = false;
  window.percentViewed50 = false;
  window.percentViewed75 = false;
  if (video.cuePoints.length !== 0) {
    let overlays = video.cuePoints.map((cp) => {
      let content = `<div style='margin:0px;padding: 10px 10px 0px 10px;'><br /><div style='margin:0px;padding:5px;width:100%;height:100%;background-color: rgba(66,85,99, .75);color:white;text-align: left;'><div style='margin:5px;padding:5px;'>${cp.comment}<a class='hpevgeoverlaylink' href='${cp.httpLink}' target='_blank'><span style='color:#2AD2C9 !important;text-decoration: underline;'>${cp.linkText}</span></a></div></div></div>`;

      return {
        align: cp.position,
        attachToControlBar: false,
        showBackground: false,
        content: content,
        start: cp.start,
        end: cp.end,
      };
    });
    if (myPlayer.overlay) {
      myPlayer.overlay({
        overlays: overlays,
      });
    }
  }

  myPlayer.one("loadedmetadata", function () {
    let lang = query?.lang;
    let mappedLang = getMappedLang(lang);
    let urlMappedLang = mappedLang?.value;
    let videoLangTag = "lang:[";
    let textTracks = myPlayer.textTracks();
    let audioTracks = myPlayer.audioTracks();
    let browserLang = navigator.language || navigator.userLanguage;
    let selectedLangCulture = urlMappedLang ?? lang ?? video.language;
    let browserLangCulture =
      browserLang.indexOf("-") === -1
        ? browserLang + "-" + browserLang.toUpperCase()
        : browserLang;
    let browserLangInfo = browserLangCulture.split("-");
    let selectedLangInfo = selectedLangCulture.split("-");
    let selectedLang =
      selectedLangInfo[0] + "-" + selectedLangInfo[1].toUpperCase();
    let browserLangTextTrack = textTracks.tracks_.find(function (track) {
      return track.language === browserLangCulture;
    });
    let selectedLangTextTrack = textTracks.tracks_.find(function (track) {
      return track.language === selectedLang;
    });
    let browserLangAudioTrack = _.find(audioTracks, (at) => {
      return at.language === browserLangInfo[0] || at.language === browserLang;
    });
    let selectedLangAudioTrack = _.find(audioTracks, (at) => {
      return (
        at.language === selectedLangInfo[0] || at.language === selectedLang
      );
    });
    let langTag = myPlayer.mediainfo.tags.find(function (tag) {
      return tag.indexOf(videoLangTag) !== -1;
    });
    let cultureLang = langTag
      .replace(videoLangTag, "")
      .replace("]", "")
      .split("-");
    let audioLangCulture = cultureLang[0] + "-" + cultureLang[1].toUpperCase();

    window.console.log(`browserLang: ${browserLang}`);
    window.console.log(`selectedLang: ${selectedLang}`);
    window.console.log(`audioLangCulture: ${audioLangCulture}`);
    window.console.log(
      `selectedLangTextTrack: ${selectedLangTextTrack ? "found" : "not found"}`
    );
    window.console.log(
      `browserLangTextTrack: ${browserLangTextTrack ? "found" : "not found"}`
    );
    window.console.log(
      `selectedLangAudioTrack: ${selectedLangAudioTrack ? "found" : "not found"
      }`
    );
    window.console.log(
      `browserLangAudioTrack: ${browserLangAudioTrack ? "found" : "not found"}`
    );

    if (selectedLangAudioTrack && audioLangCulture !== selectedLang) {
      selectedLangAudioTrack.enabled = true;
    } else if (
      browserLangAudioTrack &&
      audioLangCulture !== browserLangCulture
    ) {
      browserLangAudioTrack.enabled = true;
    }
    if (!showCaptionsDefined) {
      if (selectedLangTextTrack && audioLangCulture !== selectedLang) {
        selectedLangTextTrack.mode = "showing";
      } else if (
        browserLangTextTrack &&
        audioLangCulture !== browserLangCulture
      ) {
        browserLangTextTrack.mode = "showing";
      }
    }
    if (showCaptions) {
      if (selectedLangTextTrack) {
        selectedLangTextTrack.mode = "showing";
      } else if (browserLangTextTrack) {
        browserLangTextTrack.mode = "showing";
      }
    }
    if (timeParam) {
      let sPattern = new RegExp("(\\d+)s*", "gi");
      let hmsPattern = new RegExp("(\\d+)h(\\d+)m(\\d+)s*", "gi");
      let hmsMathces = hmsPattern.exec(timeParam);
      let sMathces = sPattern.exec(timeParam);
      let startTime = 0;

      if (hmsMathces !== null) {
        let hours = Number.parseInt(hmsMathces[1]);
        let minutes = Number.parseInt(hmsMathces[2]);
        let seconds = Number.parseInt(hmsMathces[3]);

        startTime = (hours * 3600) + (minutes * 60) + seconds;
      }
      else if (sMathces !== null) {
        startTime = Number.parseInt(sMathces[1]);
      }
      myPlayer.currentTime(startTime);
    }
    if (autoplay) {
      let volumeLevel = 0.7;

      window.digitalData.promises.trackMetricsReady.then(function () {
        window.trackMetrics("hva.video.autostart", {
          videoName: video.name,
          playerType: "brightcove",
          assetId: _uaid,
          parentPage: `video-gallery:${video.name}`,
        });
      });
      setTimeout(() => {
        myPlayer
          .play()
          .then(function () {
            // Autoplay started!
            // If video playing unmute and set the volume
            myPlayer.muted(false);
            myPlayer.volume(volumeLevel);
          })
          .catch(function (error) {
            // Autoplay was prevented.
            // +++ If autoplay prevented mute the video, play video and display unmute button +++
            myPlayer.muted(true);
            setTimeout(() => {
              myPlayer.play().then(function () {
                // Autoplay started!
                // +++ If Chrome or Firefox show captions as unmuting will stop play
                if (selectedLangTextTrack) {
                  selectedLangTextTrack.mode = "showing";
                } else if (browserLangTextTrack) {
                  browserLangTextTrack.mode = "showing";
                }
              });
            }, 200);
          });
      }, 300);
    }
  });

  myPlayer.one("play", function () {
    window.digitalData.promises.trackMetricsReady.then(function () {
      window.trackMetrics("hva.videostart", {
        videoName: video.name,
        playerType: "brightcove",
        assetId: _uaid,
        parentPage: `video-gallery:${video.name}`,
      });
    });
  });

  myPlayer.on("timeupdate", function () {
    let currentTime = Number(this.currentTime());
    let duration = Number(this.duration());
    let percentViewed = Math.floor((currentTime / duration) * 100);

    switch (true) {
      case percentViewed >= 25 && !window.percentViewed25:
        window.percentViewed25 = true;
        window.digitalData.promises.trackMetricsReady.then(function () {
          window.trackMetrics("hva.video25", {
            videoName: video.name,
            playerType: "brightcove",
            assetId: _uaid,
            parentPage: `video-gallery:${video.name}`,
          });
        });
        break;
      case percentViewed >= 50 && !window.percentViewed50:
        window.percentViewed50 = true;
        window.digitalData.promises.trackMetricsReady.then(function () {
          window.trackMetrics("hva.video50", {
            videoName: video.name,
            playerType: "brightcove",
            assetId: _uaid,
            parentPage: `video-gallery:${video.name}`,
          });
        });
        break;
      case percentViewed >= 75 && !window.percentViewed75:
        window.percentViewed75 = true;
        window.digitalData.promises.trackMetricsReady.then(function () {
          window.trackMetrics("hva.video75", {
            videoName: video.name,
            playerType: "brightcove",
            assetId: _uaid,
            parentPage: `video-gallery:${video.name}`,
          });
        });
        break;
      default:
        break;
    } // end switch percentViewed
  });

  myPlayer.one("ended", function () {
    window.digitalData.promises.trackMetricsReady.then(function () {
      window.trackMetrics("hva.videocomplete", {
        videoName: video.name,
        playerType: "brightcove",
        assetId: _uaid,
        parentPage: `video-gallery:${video.name}`,
      });
    });
  });

  if (!isMax) {
    let location = window.location;
    let mainUrl = location.href.match(/http(s)*:\/\/.*\/\w+-\w+\//gi)[0];
    let rootUrl = mainUrl.substr(0, mainUrl.lastIndexOf("/"));
    let options = {
      label: "Sharing Dialog",
      name: "SocialOverlay",
      url: video.href.startsWith(rootUrl)
        ? video.href
        : `${rootUrl}${video.href}`,
      embedCode: iframe,
      deeplinking: false,
      displayAfterVideo: true,
      services: {
        facebook: !isMax,
        twitter: !isMax,
        tumblr: !isMax,
        pinterest: !isMax,
        linkedin: !isMax,
      },
    };
    if (myPlayer.social) {
      myPlayer.social(options);
    }
  } else {
    window.digitalData.promises.DCEReady.then(function () {
      hideChat();
    });
  }
  myPlayer.errors({
    errors: {
      "-1": {
        headline: "This video currently not available for streaming.",
        type: "PLAYER_ERR_NO_SRC",
        message: "No video has been loaded.",
      },
    },
  });
};

const hideChat = () => {
  let chatBtn = window.jQuery("#root");

  if (chatBtn.length !== 0) {
    window.DCEData.chatFunctions.hideDCE();
  } else {
    setTimeout(function () {
      hideChat();
    }, 1000);
  }
};

export const showScroll = (show) => {
  if (show) {
    window
      .jQuery("#main-body", "#content-body", "#body", "#content", "#everything")
      .addClass("loading-container");
  } else {
    window
      .jQuery("#main-body", "#content-body", "#body", "#content", "#everything")
      .removeClass("loading-container");
  }
};

export const formatString = (format, params) => {
  let results = format;

  if (results) {
    params.forEach((param, index) => {
      let patt = new RegExp("\\{" + index + "\\}", "g");

      results = results.replace(patt, param);
    });
  }
  return results ?? "";
};
